module.exports = __webpack_public_path__ + "assets/202509252035/img/timeline.001667e8.png";